import {useCallback, useEffect, useState} from 'react'

function getTargetElement(target) {
  if (!target) return document.body
  if (typeof target === 'function') {
    return target()
  }
  if ('current' in target) {
    return target.current
  }
  return target
}

function useDisableTouchMove(target, initDisable = true) {
  const [disable, setDisable] = useState(initDisable)
  const touchMoveHandle = useCallback(
    (event) => {
      if (disable) {
        event.preventDefault()
      }
    },
    [disable]
  )

  useEffect(() => {
    const el = getTargetElement(target)
    el.addEventListener('touchmove', touchMoveHandle)
    return () => {
      el.removeEventListener('touchmove', touchMoveHandle)
    }
  }, [target, touchMoveHandle])

  return [disable, setDisable]
}

export {useDisableTouchMove}
